export const titleCase = (str) => {
  const splitStr = str.toLowerCase().split(' ');
  for (let i = 0; i < splitStr.length; i += 1) {
    splitStr[i] =
      splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  return splitStr.join(' ');
};

export const GENDERS = [
  { value: 'male', label: 'Hombre' },
  { value: 'female', label: 'Mujer' },
];

export const SIZES = [
  { value: 'XS', label: 'XS' },
  { value: 'S', label: 'S' },
  { value: 'M', label: 'M' },
  { value: 'L', label: 'L' },
  { value: 'XL', label: 'XL' },
  { value: 'XXL', label: 'XXL' },
  { value: '3XL', label: '3XL' },
  { value: '4XL', label: '4XL' },
];

/** distance numérico alineado con STARLIST / tnc-admin (12H 2026) */
export const DEFAULT_DISTANCE_INDIVIDUAL = 3; // 12H
export const DEFAULT_DISTANCE_TEAM = 3; // 12H equipos

export const DISTANCE_USER = [
  { value: 1, label: '10K' },
  { value: 2, label: '22K' },
  { value: 0, label: '6H' },
  { value: 3, label: '12H' },
];

export const DISTANCE_TEAM = [
  { value: 4, label: '6H' },
  { value: 3, label: '12H' },
];

/** Cada vuelta en el circuito 12H son 2 km. */
export const LAP_DISTANCE_KM = 2;

export const getParticipantBibNumber = (person) => {
  const bib = person?.bib_number ?? person?.bibNumber;
  if (bib === null || bib === undefined) return '';
  return String(bib).trim();
};

/** Nombre y dorsal por separado (chip: nombre izq, dorsal der). */
export const getParticipantChipParts = (person) => {
  const name = `${person?.name || ''} ${person?.last_name || person?.lastName || ''}`
    .trim()
    .replace(/\s+/g, ' ');
  const bib = getParticipantBibNumber(person);
  return { name, bib };
};

/** Etiqueta plana (fallback) */
export const formatParticipantChipLabel = (person) => {
  const { name, bib } = getParticipantChipParts(person);
  if (!name) return bib || '';
  if (!bib) return name;
  return `${name} | ${bib}`;
};

export const roundDistanceKm = (km) => {
  const n = Number(km);
  if (!Number.isFinite(n) || n <= 0) return 0;
  return Math.round(n * 10) / 10;
};

/** Total cerrado: vueltas × 2 km. */
export const distanceFromLapCount = (lapCount) => {
  const n = Number(lapCount) || 0;
  return n > 0 ? n * LAP_DISTANCE_KM : 0;
};

/** Si el total reportado es ~múltiplo de 2 km, alinear al circuito. */
export const snap12hTotalKm = (km) => {
  const n = Number(km);
  if (!Number.isFinite(n) || n <= 0) return 0;
  const laps = Math.round(n / LAP_DISTANCE_KM);
  const snapped = laps * LAP_DISTANCE_KM;
  if (Math.abs(n - snapped) <= 0.6) return snapped;
  return roundDistanceKm(n);
};

export const formatDistanceKm = (km) => {
  const rounded = roundDistanceKm(km);
  if (rounded === 0) return '0';
  return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
};

export const resolveDisplayDistanceKm = (totalKm, lapCount) => {
  if (lapCount > 0) return distanceFromLapCount(lapCount);
  return snap12hTotalKm(totalKm);
};

export const DISTANCE_LABELS = {
  0: '6H',
  1: '10K',
  2: '22K',
  3: '12H',
  4: '6H',
};

export const BIKES = [
  'AGR',
  'ARGON',
  'ARGON18',
  'BASSO',
  'BIANCHI',
  'BLUE',
  'BMC',
  'BTWIN',
  'CANNONDALE',
  'CANYON',
  'CEEPO',
  'CERVELO',
  'COLNAGO',
  'CUBE',
  'DEROSA',
  'FACTOR',
  'FELT',
  'FOCUS',
  'FUJI',
  'GIANT',
  'GUERCIOTTI',
  'GW',
  'KESTREL',
  'KTM',
  'LAPIERRE',
  'LIV',
  'LOOK',
  'MERIDA',
  'ORBEA',
  'PINARELLO',
  'QUINTANAROO',
  'RALEIGH',
  'RIDLEY',
  'ROSSETTI',
  'SCOTT',
  'SPECIALIZED',
  'STL',
  'TREK',
  'URANIUM',
  'WILIER',
];

export const SHOES = [
  'Nike',
  'Adidas',
  'Asics',
  'Brooks',
  'New Balance',
  'Saucony',
  'Hoka',
  'Otra',
];
